import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Col, Container, Row } from 'react-bootstrap';

const HotelDetailLoader = () => (
  <SkeletonTheme baseColor="#202020" highlightColor="#444">
    <Row className="gx-3">
      <Col sm="4">
        <Skeleton height={400} />
      </Col>
      <Col sm="4">
        <Skeleton height={400} />
      </Col>
      <Col sm="4">
        <Skeleton height={400} />
      </Col>
    </Row>
    <Container>
      <Row className="mt-5 px-md-10 px-sm-2">
        <Col md={6}>
          <Skeleton height={70} className="my-5" />
          <Skeleton count={30} />
        </Col>
        <Col md={6}>
          <Skeleton height={300} className="my-5" />
          <Skeleton count={20} />
        </Col>
      </Row>
    </Container>
  </SkeletonTheme>
);
export default HotelDetailLoader;
